// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"273":"960f419e","293":"4c1cbd05","396":"4c1cbd05","775":"4b6cc239"}[chunkId] + ".chunk.css";
};